/**
 * Portal-agnostic ad placement names (kebab-case).
 * Rewarded: `requestRewardedAd({ name })` — Y8 maps to `showAd({ type: "reward", name })`;
 * YouTube maps via {@link resolveYtRewardPlacementId}; CrazyGames accepts and ignores `name`.
 * Interstitial (Y8 / YouTube / Playgama): Play Again + NEXT DAY at `cycleIndex` 4, 8, 12, … .
 * Poki and GameDistribution NEXT DAY: after `cycleIndex` >= 4, every continue; the portal
 * chooses whether an ad plays. Poki also breaks on unpause and Play Again after that unlock.
 * CrazyGames has no interstitials.
 * Playgama `showInterstitial(placement)`; Y8 typed `showAd`; YouTube untyped
 * `requestInterstitialAd()`; Poki `commercialBreak()`. Fall complete is not a rest.
 */

export const REWARD_AD_NAME_REVIVE = "revive";
export const REWARD_AD_NAME_WHEEL_SPIN = "wheel-spin";
export const REWARD_AD_NAME_EXTRA_GEMS = "extra-gems";

export const INTERSTITIAL_AD_NAME_PLAY_AGAIN = "play-again";
export const INTERSTITIAL_AD_NAME_FALL_COMPLETE = "fall-complete";
export const INTERSTITIAL_AD_NAME_NEXT_DAY = "next-day";

/** YouTube Playables placement ids — register matching rewards in the Playables dashboard. */
export const YT_REWARD_AD_ID_REVIVE = "reward-revive";
export const YT_REWARD_AD_ID_WHEEL_SPIN = "reward-spin";
export const YT_REWARD_AD_ID_EXTRA_GEMS = "reward-gems";

var YT_REWARD_ID_BY_LOGICAL_NAME = {
  revive: YT_REWARD_AD_ID_REVIVE,
  "wheel-spin": YT_REWARD_AD_ID_WHEEL_SPIN,
  "extra-gems": YT_REWARD_AD_ID_EXTRA_GEMS,
};

/**
 * @param {string | undefined} logicalName — {@link REWARD_AD_NAME_REVIVE} etc.
 * @returns {string} id passed to `ytgame.ads.requestRewardedAd`
 */
export function resolveYtRewardPlacementId(logicalName) {
  var key = typeof logicalName === "string" ? logicalName.trim() : "";
  if (key && YT_REWARD_ID_BY_LOGICAL_NAME[key]) {
    return YT_REWARD_ID_BY_LOGICAL_NAME[key];
  }
  return key || "reward";
}
